import './validator/initialisation';
import intlTelInput from 'intl-tel-input';
import { pl } from 'intl-tel-input/i18n';
import 'country-select-js/build/js/countrySelect'

export function getRecaptcha() {
	let url = new URL(document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]').src);
	let params = new URLSearchParams(url.search);
	return grecaptcha.execute(params.get('render'));
};

$.fn.ajaxInvalidFeedback = function(options) {
	return this.each(function() {
		let object = $(this).data('ajaxInvalidFeedback');
		if (typeof options == 'object') {
			$(this).addClass('has-invalid-feedback-ajax').after(`
				<div class='invalid-feedback invalid-feedback-ajax d-block'>${options.error}</div>
			`);
			let destroyHandler = () => $(this).ajaxInvalidFeedback('destroy');
			$(this).on('change input', destroyHandler);
			$(this.form).on('submit', destroyHandler);
			$(this).data('ajaxInvalidFeedback', {destroyHandler});
		} else if (options === 'destroy') {
			$(this).off('change input', object.destroyHandler).removeClass('has-invalid-feedback-ajax').siblings('.invalid-feedback-ajax').remove();
			$(this.form).off('submit', object.destroyHandler);
			$(this).data('ajaxInvalidFeedback', null);
		}
	});
};

$.fn.toggleValid = function (valid) {
    this.each((i, element) => element.setCustomValidity(valid ? "" : 'invalid'));
};

export function processFormErrors(errors, form) {
	for (let fieldName in errors) {
		if (fieldName == form.name) {
			for (let error of errors[fieldName]) {
				alert(error);
			}
		} else {
			let error = errors[fieldName].join('<br>');
			$(form.elements[fieldName]).ajaxInvalidFeedback({error: error});
		}
	}
};

export async function setRecaptchaResponse(form) {
    if ($(form).data('recaptcha') && !$(form.elements).filter('.g-recaptcha-response').length) {
		let fieldName = typeof $(form).data('recaptcha') == 'string' ? $(form).data('recaptcha') : 'g-recaptcha-response';
        $(form).append(`<input type="hidden" name="${fieldName}" class="g-recaptcha-response">`);
    }
    if ($(form.elements).filter('.g-recaptcha-response').length) {
        $(form.elements).filter('.g-recaptcha-response').val(await getRecaptcha());
    }
};

$('#application-confirm-modal-ok-button').on('click', function () {
    $('#form-application').removeClass('form-application');
    $('#form-application').trigger('submit');
});

$('.ajax-form').on('submit', async function(event) {
	event.preventDefault();


    if ($(this).hasClass('form-application')) {
        $('#application-confirm-modal').modal('show');

        return false;
    } else {
        $(this.elements).filter('[type=submit]').prop('disabled', true);
        await setRecaptchaResponse(this);

        try {
            var data = await $.ajax({
                type: 'post',
                url: this.action,
                data: new FormData(this),
                processData: false,
                contentType: false,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            });
        } catch (xhr) {
            let errorEvent = $.Event('submit-error');
            $(this).trigger(errorEvent, xhr);
            if (!errorEvent.isDefaultPrevented()) {
                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    processFormErrors(xhr.responseJSON.errors, this);
                } else {
                    alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
                }
            }
            $(this).find('.invalid-feedback:visible:first')[0]?.scrollIntoView({ behavior: "smooth", block: 'center' });
            return;
        } finally {
            $(this.elements).filter('[type=submit]').prop('disabled', false);
        }
        let successEvent = $.Event('submit-success');
        $(this).trigger(successEvent, data);
        if (!successEvent.isDefaultPrevented()) {
            this.reset();
            $(this).removeClass('was-validated');
            $(this).find('.has-invalid-feedback-ajax').ajaxInvalidFeedback('destroy');
            $(this).find('.form-file .btn-remove').hide();
            $(this).find('img[data-src]').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
            if (data.redirect) location.href = data.redirect;
        };   
    }
});

const phone1 = document.querySelector("#phone1");

if (phone1) {
    const phone1Input = intlTelInput(phone1, {
        i18n: pl,
        separateDialCode: true,
        strictMode: true,
        useFullscreenPopup: false,
        initialCountry: 'auto',
        geoIpLookup: function(success, failure) {
            fetch("https://ipapi.co/json")
                .then(function(res) { return res.json(); })
                .then(function(data) { success(data.country_code); })
                .catch(function() { failure(); });
        },
        loadUtilsOnInit: () => import("intl-tel-input/utils")
    });

    $('#phone1').on('change', function () {
        if ($('[name="personal_data[phone]"]').length) {
            $('[name="personal_data[phone]"]').val(phone1Input.getNumber())
        } else {
            $('[name="statement[phone]"]').val(phone1Input.getNumber())
        }
    });
}

$('[name="personal_data[donorType]"]').on('change', function () {
    $('fieldset.data-container').addClass('d-none').attr('disabled', true);
    const val = $(this).val();
    const toShow = `fieldset.${val}-container`;
    $(toShow).removeClass('d-none').attr('disabled', false);

    $('.rule-container').removeClass('d-none');
    $('#application-button').removeClass('d-none');
});

$('#country1').countrySelect({
    defaultCountry: "pl",
    preferredCountries: [],
    i18n: "pl",
    localizedCountries: { 'pl': 'Polska' },
});

const phone2 = document.querySelector("#phone2");

if (phone2) {
    const phone2Input = intlTelInput(phone2, {
        i18n: pl,
        separateDialCode: true,
        strictMode: true,
        useFullscreenPopup: false,
        initialCountry: 'auto',
        geoIpLookup: function (success, failure) {
            fetch("https://ipapi.co/json")
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    success(data.country_code);
                })
                .catch(function () {
                    failure();
                });
        },
        loadUtilsOnInit: () => import("intl-tel-input/utils")
    });

    $('#phone2').on('change', function () {
        $('[name="personal_data[phone]"]').val(phone2Input.getNumber())
    });
}

$('#country2').countrySelect({
    defaultCountry: "pl",
    preferredCountries: [],
    i18n: "pl",
    localizedCountries: { 'pl': 'Polska' },
});

const phone3 = document.querySelector("#phone3");

if (phone3) {
    const phone3Input = intlTelInput(phone3, {
        i18n: pl,
        separateDialCode: true,
        strictMode: true,
        useFullscreenPopup: false,
        initialCountry: 'auto',
        geoIpLookup: function (success, failure) {
            fetch("https://ipapi.co/json")
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    success(data.country_code);
                })
                .catch(function () {
                    failure();
                });
        },
        loadUtilsOnInit: () => import("intl-tel-input/utils")
    });

    $('#phone3').on('change', function () {
        $('[name="personal_data[phone]"]').val(phone3Input.getNumber());
    });
}

$('#country3').countrySelect({
    defaultCountry: "pl",
    preferredCountries: [],
    i18n: "pl",
    localizedCountries: { 'pl': 'Polska' },
});

$('[name="statement[type]"]').on('change', function () {
    $('fieldset.data-container').removeClass('d-none').attr('disabled', false);

    if ($(this).val() === 'usługę') {
        $('fieldset.service-container').removeClass('d-none').attr('disabled', false);
    } else {
        $('fieldset.service-container').addClass('d-none').attr('disabled', true);
    }

    $('#statement-button').removeClass('d-none');
});

$('[name="statement[date]"]').datepicker({
    format: 'yyyy-mm-dd',
    startDate: new Date($('[name="statement[date]"]').data('min')),
    defaultViewDate: 'today',
    startView: 'days',
    minViewMode: 'days',
    maxViewMode: 'days',
    keyboardNavigation: false,
    weekStart: 1,
    language: 'pl'
});

$('[name="personal_data[nonip]"]').on('change', function () {
    if ($(this).is(':checked')) {
        $('[name="personal_data[nip]"]').attr('required', false).attr('disabled', true);
    } else {
        $('[name="personal_data[nip]"]').attr('required', true).attr('disabled', false);
    }
});

$('[name="personal_data[noregon]"]').on('change', function () {
    if ($(this).is(':checked')) {
        $('[name="personal_data[regon]"]').attr('required', false).attr('disabled', true);
    } else {
        $('[name="personal_data[regon]"]').attr('required', true).attr('disabled', false);
    }
});
